var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmiley(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1083 9.05027C12.038 9.01355 11.9591 8.99414 11.8799 8.99414C11.6938 8.99414 11.525 9.09686 11.4392 9.26252C10.8688 10.3671 9.51878 11.0005 8 11.0005C6.44581 11.0005 5.0675 10.3579 4.57009 9.28183C4.48919 9.10717 4.31247 8.99436 4.11987 8.99436C4.04819 8.99436 3.97859 9.00952 3.91181 9.04008C3.66412 9.15489 3.55565 9.44998 3.67012 9.69811C4.32656 11.1181 6.06659 12.0005 8 12.0005C9.88563 12.0005 11.5814 11.148 12.32 9.71752C12.4453 9.47498 12.3499 9.17542 12.1083 9.05027Z",
    fill: "#73777C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8997 7.22419C12.5721 6.79978 12.1569 6.5 11.5042 6.5C10.8514 6.5 10.4397 6.79916 10.1101 7.22241C9.93814 7.44309 9.96867 7.74219 10.2271 7.91638C10.3182 7.97772 10.4255 8 10.5374 8C10.706 7.99997 10.8657 7.93409 10.9646 7.80691C11.0724 7.66831 11.2054 7.5 11.5042 7.5C11.8045 7.5 11.9364 7.66753 12.0426 7.80553C12.1419 7.93378 12.3022 8 12.4713 8C12.5832 8 12.6902 7.97787 12.7813 7.91616C13.0173 7.75578 13.0704 7.44531 12.8997 7.22419Z",
    fill: "#73777C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89968 7.22419C5.57218 6.79978 5.15692 6.5 4.5042 6.5C3.85147 6.5 3.43972 6.79916 3.11006 7.22241C2.93815 7.44309 2.96865 7.74219 3.22715 7.91638C3.31822 7.97772 3.42547 8 3.53738 8C3.70597 7.99997 3.86572 7.93409 3.96454 7.80691C4.07238 7.66831 4.20541 7.5 4.5042 7.5C4.80451 7.5 4.93645 7.66753 5.04264 7.80553C5.14192 7.93378 5.30214 8 5.47127 8C5.58321 8 5.69024 7.97787 5.78134 7.91616C6.01737 7.75578 6.07046 7.44531 5.89968 7.22419Z",
    fill: "#73777C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 4.134 4.134 1 8 1C11.866 1 15 4.134 15 8C15 11.866 11.866 15 8 15C4.134 15 1 11.866 1 8ZM7.99999 14C9.60265 14 11.1094 13.3759 12.2427 12.2427C13.3759 11.1094 14 9.60266 14 8C14 6.39734 13.3759 4.89062 12.2427 3.75734C11.1094 2.62413 9.60265 2 7.99999 2C6.39733 2 4.89061 2.62413 3.75733 3.75734C2.62411 4.89062 1.99999 6.39734 1.99999 8C1.99999 9.60266 2.62411 11.1094 3.75733 12.2427C4.89061 13.3759 6.39733 14 7.99999 14Z",
    fill: "#73777C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.0a6a2c71300910ec0c17101be6fa5cb5.svg";
export { ForwardRef as ReactComponent };